(function () {
  const panels = ['user-panel', 'cart-panel'];

  panels.forEach((id) => {
    const wrapper = document.getElementById(id);
    if (!wrapper) return;

    const panel = wrapper.querySelector('[data-off-canvas-panel]');
    const toggles = document.querySelectorAll('[data-off-canvas-toggle="' + id + '"]');
    const closes = wrapper.querySelectorAll('[data-off-canvas-close]');

    function open() {
      wrapper.classList.remove('hidden');
      requestAnimationFrame(() => {
        panel.classList.remove('translate-x-full');
      });
    }

    function close() {
      panel.classList.add('translate-x-full');
      panel.addEventListener('transitionend', function handler() {
        wrapper.classList.add('hidden');
        panel.removeEventListener('transitionend', handler);
      });
    }

    toggles.forEach((btn) => (btn.onclick = open));
    closes.forEach((btn) => (btn.onclick = close));
  });

  if (!window.openOffCanvas) {
    window.openOffCanvas = function (targetId) {
      const targetWrapper = document.getElementById(targetId);
      if (!targetWrapper) return;
      const targetPanel = targetWrapper.querySelector('[data-off-canvas-panel]');
      targetWrapper.classList.remove('hidden');
      requestAnimationFrame(() => {
        targetPanel.classList.remove('translate-x-full');
      });
    };
  }
})();

document.addEventListener('DOMContentLoaded', function () {
  const cartContent = document.querySelector('#cart-content');

  if (!cartContent) return;

  document.addEventListener('click', function (e) {
    if (!e.target.closest('#cart-content')) return;

    const minusBtn = e.target.closest('[data-cart-qty-minus]');
    if (minusBtn) {
      const key = minusBtn.getAttribute('data-cart-qty-minus');
      updateCartQuantity(key, -1);
    }

    const plusBtn = e.target.closest('[data-cart-qty-plus]');
    if (plusBtn) {
      const key = plusBtn.getAttribute('data-cart-qty-plus');
      updateCartQuantity(key, 1);
    }

    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      const key = removeBtn.getAttribute('data-cart-remove');
      removeCartItem(key);
    }
  });

  async function updateCartQuantity(lineIndex, change, absolute = false) {
    try {
      const currentCartContent = document.querySelector('#cart-content');
      if (!currentCartContent) return;

      const currentItem = currentCartContent.querySelector(`[data-cart-qty-input="${lineIndex}"]`);
      if (!currentItem) return;

      showLoadingIndicator(lineIndex);

      const currentQty = parseInt(currentItem.value);

      let newQty;
      if (absolute) {
        newQty = change;
      } else {
        newQty = currentQty + change;
      }

      if (newQty < 1) {
        newQty = 1;
      }

      const response = await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||"/")+"cart/change.js", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: parseInt(lineIndex),
          quantity: newQty,
        }),
      });

      if (response.ok) {
        await refreshCartContent();
      }
    } catch (error) {
      hideLoadingIndicator(lineIndex);
    }
  }

  async function removeCartItem(lineIndex) {
    try {
      showLoadingIndicator(lineIndex);

      const response = await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||"/")+"cart/change.js", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          line: parseInt(lineIndex),
          quantity: 0,
        }),
      });

      if (response.ok) {
        await refreshCartContent();
      }
    } catch (error) {
      hideLoadingIndicator(lineIndex);
    }
  }

  function showLoadingIndicator(lineIndex) {
    const spinner = document.querySelector(`[data-cart-loading="${lineIndex}"]`);
    if (spinner) {
      spinner.classList.remove('hidden');
    }
  }

  function hideLoadingIndicator(lineIndex) {
    const spinner = document.querySelector(`[data-cart-loading="${lineIndex}"]`);
    if (spinner) {
      spinner.classList.add('hidden');
    }
  }

  async function refreshCartContent() {
    try {
      const response = await fetch(window.location.href);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartContent = doc.querySelector('#cart-content');
      const currentCartContent = document.querySelector('#cart-content');

      if (newCartContent && currentCartContent) {
        currentCartContent.innerHTML = newCartContent.innerHTML;

        updateCartBadge();
      }
    } catch (error) {
      console.error('Fehler beim Aktualisieren des Warenkorbs:', error);
    }
  }

  async function updateCartBadge() {
    try {
      const cartResponse = await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||"/")+"cart.js");
      const cartData = await cartResponse.json();

      document.querySelectorAll('[data-cart-count]').forEach((badge) => {
        badge.textContent = cartData.item_count;
        if (cartData.item_count > 0) {
          badge.style.display = 'flex';
        } else {
          badge.style.display = 'none';
        }
      });
    } catch (error) {
      console.error('Fehler beim Aktualisieren des Cart-Badges:', error);
    }
  }

  window.refreshCartContent = refreshCartContent;
  window.updateCartBadge = updateCartBadge;
});
